import React from "react";
import "./FeedbackBanner.scss";
import { useNavigate } from "react-router-dom";

const FeedbackBanner = ({
  modalFunction,
  heading,
  para,
  buttonText,
  imgSrc,
}) => {
  const navigate=useNavigate();
  const handleOpenFeedback = () => {
    buttonText=="Add external Review"?(navigate('review')):modalFunction();
    
  };

  return (
    <div className="feedback-banner">
      <div className="content">
        <div className="text-section">
          <h3>{heading}</h3>
          <p>{para}</p>
          <button className="participate-btn" onClick={handleOpenFeedback}>
            {buttonText}
          </button>
        </div>
        <div className="image-section">
          <img src={imgSrc} alt="Feedback Illustration" />
        </div>
      </div>
    </div>
  );
};

export default FeedbackBanner;
